import { Property } from "@ploy-lib/types";
import {
	FieldType,
	IFormTableSchema,
	TableMetadata,
	ColumnMetadata
} from "./types";
import { Lien } from "@ploy-lib/types";

export class LienSchema implements IFormTableSchema<Lien> {
	tableMetadata: TableMetadata<Partial<Lien>> = {
		addRowButtonIsDisabled: (form, row) => {
			const properties = (form?.["Calculator"]?.["PROPERTIES"] ||
				[]) as Property[];
			return properties.length === 0;
		},
		isDeletableRow(rowData, cells) {
			return Boolean(rowData.addedManually);
		}
	};

	columnMetadata: Partial<Record<keyof Lien, ColumnMetadata<Lien>>> = {
		creditorOrgNo: {
			fieldType: FieldType.Text,
			isRequired: true
		},
		creditorName: {
			fieldType: FieldType.Text,
			isRequired: true
		},
		registrationDate: {
			fieldType: FieldType.Date
		},
		priority: {
			fieldType: FieldType.Number
		},
		yieldPriority: {
			fieldType: FieldType.Checkbox
		},
		documentId: {
			fieldType: FieldType.Text
		},
		value: {
			fieldType: FieldType.Currency
		},
		writtenDownValue: {
			fieldType: FieldType.Currency
		},
		propertyId: {
			fieldType: FieldType.Select,
			isRequired: true,
			displayValue(
				value,
				rowData,
				cells,
				isPlaceholder,
				firstInGroup,
				formValues
			) {
				const properties = (formValues?.["Calculator"]?.["PROPERTIES"] ||
					[]) as Property[];
				return properties.find(x => x.propertyId === value)
					?.propertyInformation;
			},
			isEditableFunctions: {
				canEditPropertyId: (form, columnCells) => {
					const rowIsAddedManually = columnCells.some(
						c => c.row.original.addedManually
					);
					return rowIsAddedManually;
				}
			}
		},
		addedManually: {
			// Need column-metadata for this field even though this field is not rendered in the FormTable.
			// We need this defaultvalue to be set for every new entity
			fieldType: FieldType.Hidden,
			defaultValue: true
		}
	};
}
